<template>
  <b-row>
    <template v-for="(comp, index) in this.internalFormComponents" :key="comp.uniqueTitle">
      <component
        :is="comp"
        v-if="comp"
        v-bind:formComponents="comp.formComponents"
        v-bind:uniqueTitle="comp.uniqueTitle"
        v-bind:placeholder="comp.placeholder"
        v-bind:fieldLabel="comp.fieldLabel"
        v-bind:description="comp.description"
        v-bind:checkedDescription="comp.checkedDescription"
        v-bind:choices="comp.choices"
        v-bind:displayStyle="comp.displayStyle"
        v-bind:selectionMode="comp.selectionMode"
      />
      <FormFieldDescription :description="comp.description" :description-id="comp.description ? comp.uniqueTitle + '-description' : ''" />
    </template>
  </b-row>
</template>

<script>

import { markRaw } from 'vue'
import _ from 'lodash'
import FormGroup from './formgroup2.vue'
import FormFieldDescription from '../FormFieldDescription.vue'
import { formControlMap, applyFormControlProps } from './form-controls'

const inputMap = {
  ...formControlMap,
  formGroup: FormGroup
}

export default {
  props: ['formComponents'],
  data() {
    return {
      internalFormComponents: []
    }
  },
  watch: {
    formComponents: {
      immediate: true,
      handler: function () {

        this.internalFormComponents = []

        if (!this.formComponents) {

          console.log(`formrow handler called, but no formComponents are present`)
          console.log(this)

          return
        }

        for (let component of this.formComponents) {

          console.log(`formrow adding component ${component.type}`)
          console.log(component)

          let instantiatedComponent = _.cloneDeep(inputMap[component.type])

          if (!instantiatedComponent) {

            console.warn(`formrow skipping unknown component type ${component.type}`)
            continue
          }

          instantiatedComponent.uniqueTitle = component.uniqueTitle

          console.log(instantiatedComponent)

          applyFormControlProps(instantiatedComponent, component)

          if (component.components) {

            console.log(`${instantiatedComponent.uniqueTitle} with ${component.components.length} child components`)
            console.log(JSON.stringify(component.components))
          }

          this.internalFormComponents.push(markRaw(instantiatedComponent))
        }
      }
    }
  },
  components: {
    FormGroup,
    FormFieldDescription
  }
}
</script>
